var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.86,
    height: 22.86,
    viewBox: "0 0 22.86 22.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ui",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M53.558,302.238A11.3,11.3,0,0,1,36.4,299.332l.742-3.421,3.29-.611a6.07,6.07,0,0,0,5.773,4.273,5.941,5.941,0,0,0,3.536-1.152l3.161.482Z",
    transform: "translate(-34.775 -282.116)",
    fill: "#59c36a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M263.353,369.017l-.656-3.335-3.161-.482A5.941,5.941,0,0,1,256,366.352v5.4A11.412,11.412,0,0,0,263.353,369.017Z",
    transform: "translate(-244.57 -348.895)",
    fill: "#00a66c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Connected_Home_1_",
    transform: "translate(0 5.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M5.4,132.186a6.242,6.242,0,0,0,.254,1.755l-4.032,4.032a11.114,11.114,0,0,1,0-11.573l3.236.557.8,3.475A6.241,6.241,0,0,0,5.4,132.186Z",
    transform: "translate(0 -126.4)",
    fill: "#ffda2d"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M253.1,198.679a11.412,11.412,0,0,1-4.076,8.693l-3.817-3.817a5.927,5.927,0,0,0,1.862-2.2h-5.4a.663.663,0,0,1-.67-.67V196.67a.663.663,0,0,1,.67-.67h10.573a.662.662,0,0,1,.656.549A11.357,11.357,0,0,1,253.1,198.679Z",
    transform: "translate(-230.24 -187.249)",
    fill: "#4086f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M261.4,201.358a5.927,5.927,0,0,1-1.862,2.2l3.817,3.817a11.32,11.32,0,0,0,3.875-10.823.662.662,0,0,0-.656-.549H256v5.358Z",
    transform: "translate(-244.57 -187.249)",
    fill: "#4175df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M53.746,3.192a.676.676,0,0,1-.188.5L50.692,6.541a.656.656,0,0,1-.871.067A5.991,5.991,0,0,0,46.2,5.4a6.07,6.07,0,0,0-5.773,4.273L36.4,5.643A11.3,11.3,0,0,1,53.5,2.7a.7.7,0,0,1,.241.5Z",
    transform: "translate(-34.775)",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M259.616,6.608a.656.656,0,0,0,.871-.067l2.866-2.853a.675.675,0,0,0,.188-.5.7.7,0,0,0-.241-.5A11.4,11.4,0,0,0,256,0V5.4A5.991,5.991,0,0,1,259.616,6.608Z",
    transform: "translate(-244.57 0)",
    fill: "#f03800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.d05a503c.svg";
export { ForwardRef as ReactComponent };